import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';

export const Container = styled.View`
  background-color: ${({theme}) => theme.colors.background};
`;

export const Section = styled.View`
  border-style: solid;
  border-bottom-width: 1px;
  border-bottom-color: ${({theme}) => theme.colors.border};
  margin: 0 -24px;
  padding: 0 24px;
  padding-bottom: ${RFValue(12)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const ProductValueContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ValueContainer = styled.View``;

export const Value = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(16)}px;
`;

export const ValueGroup = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const ValueDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(12)}px;
`;

export const CheckoutBrand = styled.View`
  width: ${RFValue(50)}px;
  height: ${RFValue(50)}px;
  background: ${({theme}) => theme.colors.yellow};
  border: 2px solid ${({theme}) => theme.colors.image_border};
  border-radius: ${RFValue(12)}px;
  align-items: center;
  justify-content: center;
`;

export const CheckoutIcon = styled(FontAwesome5)`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(20)}px;
`;
